<template>
  <MUpload v-bind="getBindValue" @upload-success="importSuccess">
    <template #btnText>
      <slot>{{ t('common.import') }}</slot>
    </template>
  </MUpload>
</template>

<script setup lang="ts">
  import { ComponentOptionsMixin, computed, unref } from 'vue';
  import { useAttrs } from '@mts-fe/hooks';
  import { message, omit } from '@mts-fe/utils';
  import { t } from '@mts/hooks/web/useI18n';
  import { MUpload, MUploadProps } from '@mts/render/components/Upload';

  /** 同步导入-按钮 */
  defineOptions({
    name: 'SyncImportBtn',
    extends: MUpload as ComponentOptionsMixin,
    inheritAttrs: false,
  });

  const props = defineProps<MUploadProps>();
  const attrs = useAttrs();
  const getBindValue = computed(() => ({
    uploadType: 'temp' as MUploadProps['uploadType'],
    ...omit(unref(attrs), ['color', 'onClick']),
    ...omit(props, ['path', 'params']),
    btnProps: { ...props.btnProps, color: unref(attrs).color },
    openFileDialogOnClick: true,
  }));

  const emit = defineEmits(['success']);
  const importSuccess = (res) => {
    unref(attrs).onClick?.(res) || emit('success', res);
    message.success(t('c.25090229'));
  };
</script>
